export default function Marquee({ text = "Power is now a subscription", separator = "—" }) {
  const item = (
    <span className="mx-8 inline-flex items-center gap-8">
      <span className="font-display text-5xl font-extrabold uppercase tracking-tight text-white/90 md:text-7xl">
        {text}
      </span>
      <span className="text-4xl text-revo-green md:text-6xl">{separator}</span>
    </span>
  );
  return (
    <div className="overflow-hidden border-y border-white/10 bg-navy-deep py-8" data-testid="marquee">
      <div className="marquee-track">
        {Array.from({ length: 6 }).map((_, i) => (
          <span key={i}>{item}</span>
        ))}
      </div>
    </div>
  );
}
